import { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface DrPhillipContextType {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggle: () => void;
}

const DrPhillipContext = createContext<DrPhillipContextType | null>(null);

export function DrPhillipProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen((o) => !o), []);

  return (
    <DrPhillipContext.Provider value={{ isOpen, setIsOpen, toggle }}>
      {children}
    </DrPhillipContext.Provider>
  );
}

export function useDrPhillipPanel() {
  const ctx = useContext(DrPhillipContext);
  if (!ctx) {
    return {
      isOpen: false,
      setIsOpen: () => {},
      toggle: () => {},
    };
  }
  return ctx;
}
